// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3a49v","subheader":"ReorderModal_subheader__3PTNf","listWrap":"ReorderModal_listWrap__wNO3Y"};